export default function toDate(dateString) {
  if (!dateString) {
    return new Date()
  }
  const date = new Date(dateString)
  return new Date(date.getTime() + 3 * 1000 * 60 * 60)
}